import classNames from 'classnames';
import { useInView } from 'react-intersection-observer';
import { List } from 'yoso';
import { useChallengeScoreUpHistories } from '~/components/Challenge/Score/ChallengeScore.hooks';
import { ChallengeScoreUpItem } from '~/components/Challenge/Score/Item/ChallengeScoreUpItem';
import { BaseError } from '~/components/Error/BaseError';
import styles from './ChallengeScoreUpList.module.scss';

export type ChallengeScoreUpListProps = {
  eventId?: number;
  className?: string;
};
export const ChallengeScoreUpList = ({ eventId, className }: ChallengeScoreUpListProps) => {
  const { data, isFetching, fetchNextPage, hasNextPage, isFetched } = useChallengeScoreUpHistories(
    { week: eventId },
    {
      keepPreviousData: true,
    }
  );

  const nextInView = useInView({
    onChange: (inView) => inView && fetchNextPage(),
  });

  const items = data?.pages.flatMap((page) => page.historyList) ?? [];

  if (isFetched && items.length === 0) throw new BaseError('EMPTY');

  return (
    <List
      className={classNames(
        styles.root,
        { [styles.loading]: isFetching, [styles.initial]: !isFetched },
        className
      )}>
      {items.map((item) => (
        <li key={item.count}>
          <ChallengeScoreUpItem {...item} />
        </li>
      ))}
      {hasNextPage && (
        <li ref={nextInView.ref} className={styles.placeholder}>
          More
        </li>
      )}
    </List>
  );
};
